<div *ngIf="!loading; else loadingComponent" class="container">
  <div class="row">
    <div class="col-lg-12">
      <app-hono-header [companyData]="companyData"></app-hono-header>

      <div class="container p-0" *ngIf="!feedbackSubmit">
        <form class="rating-wrapper" *ngIf="!rating">
          <label class="rating-label"
            >{{ honoData?.Question }}
            <p class="honoDecription">{{ honoData?.Description }}</p>
            <div class="ratingItemList">
              <input
                *ngIf="currentSmileyPrompts?.includes('DELIGHTED')"
                class="rating rating-5"
                id="rating-5-2"
                type="radio"
                value="5"
                name="rating"
              />
              <label
                class="rating rating-5"
                for="rating-5-2"
                *ngIf="currentSmileyPrompts?.includes('DELIGHTED')"
                (click)="saveRatingAPI(5)"
                ><i class="em em-star-struck"></i>
                <p class="emotionText">Delighted</p>
              </label>
              <input
                class="rating rating-4"
                id="rating-4-2"
                type="radio"
                value="4"
                name="rating"
                *ngIf="currentSmileyPrompts?.includes('HAPPY')"
              />
              <label
                class="rating rating-4"
                for="rating-4-2"
                (click)="saveRatingAPI(4)"
                *ngIf="currentSmileyPrompts?.includes('HAPPY')"
                ><i class="em em-grinning"></i>
                <p class="emotionText">Happy</p>
              </label>
              <input
                class="rating rating-3"
                id="rating-3-2"
                type="radio"
                value="3"
                name="rating"
                *ngIf="currentSmileyPrompts?.includes('NEUTRAL')"
              />
              <label
                class="rating rating-3"
                for="rating-3-2"
                (click)="saveRatingAPI(3)"
                *ngIf="currentSmileyPrompts?.includes('NEUTRAL')"
                ><i class="em em-neutral"></i>
                <p class="emotionText">Neutral</p>
              </label>
              <input
                class="rating rating-2"
                id="rating-2-2"
                type="radio"
                value="2"
                name="rating"
                *ngIf="currentSmileyPrompts?.includes('UNHAPPY')"
              />
              <label
                class="rating rating-2"
                for="rating-2-2"
                (click)="saveRatingAPI(2)"
                *ngIf="currentSmileyPrompts?.includes('UNHAPPY')"
                ><i class="em em-expressionless"></i>
                <p class="emotionText">Unhappy</p>
              </label>
              <input
                class="rating rating-1"
                id="rating-1-2"
                type="radio"
                value="1"
                name="rating"
                *ngIf="currentSmileyPrompts?.includes('DISAPPOINTED')"
              />
              <label
                class="rating rating-1"
                for="rating-1-2"
                (click)="saveRatingAPI(1)"
                *ngIf="currentSmileyPrompts?.includes('DISAPPOINTED')"
                ><i class="em em-disappointed"></i>

                <p class="emotionText">Disappointed</p>
              </label>
            </div>
          </label>
        </form>

        <form [formGroup]="Form1" class="rating-wrapper" *ngIf="rating">
          <div class="col-md-12">
            <div class="text-center mt-4">
              <div
                class="submissionThankyou text-center my-5"
                *ngIf="
                  !(
                    allowAnonymous === 'Y' &&
                    (honoData?.PromptUserInfo === 'A' ||
                      (honoData?.PromptUserInfo === 'E' &&
                        (honoRating === 2 || honoRating === 1))) &&
                    !submitted
                  )
                "
              >
                <img
                  src="https://dkzxkcjlbnjui.cloudfront.net/uploads/media/images/check.png"
                  class="img-fluid checkImage mb-3"
                />
              </div>
              <div class="thankyouMessage">
                <h4
                  *ngIf="
                    allowAnonymous === 'N' ||
                      (allowAnonymous === 'Y' &&
                        (honoData?.PromptUserInfo === 'A' ||
                          (honoData?.PromptUserInfo === 'E' &&
                            (honoRating === 2 || honoRating === 1))) &&
                        !submitted);
                    else normalFlow
                  "
                >
                  Please fill below details to complete the survey.
                </h4>
                <ng-template #normalFlow>
                  <h4 class="text-success">
                    Thank you, Your response has been submitted.
                  </h4>
                </ng-template>
              </div>
            </div>
            <div
              class="customerDetails"
              *ngIf="
                (allowAnonymous === 'N' ||
                  (allowAnonymous === 'Y' &&
                    (honoData?.PromptUserInfo === 'A' ||
                      (honoData?.PromptUserInfo === 'E' &&
                        (honoRating === 2 || honoRating === 1))))) &&
                !submitted
              "
            >
              <div class="form-floating mb-3">
                <div class="col-md-12 form-group p-0 mt-4">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Your Name</label
                  >
                  <input
                    formControlName="Name"
                    type="text"
                    class="form-control formHeight"
                    id="inputName"
                    placeholder="Your full name"
                  />
                  <p
                    class="text-danger"
                    *ngIf="
                      Form1.controls['Name'].invalid &&
                      Form1.controls['Name'].touched &&
                      Form1.controls['Name'].errors.required
                    "
                  >
                    Enter Name
                  </p>
                </div>
              </div>
              <div class="form-floating mb-3">
                <div class="col-md-12 form-group p-0">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Your Phone Number</label
                  >
                  <input
                    formControlName="Phone"
                    type="text"
                    class="form-control formHeight"
                    id="inputPhone"
                    placeholder="Your phone number"
                    onkeypress="return event.keyCode >= 48 && event.keyCode <= 57"
                    [maxlength]="loginData?.MobileNumberLength"
                  />
                  <p
                    class="text-danger"
                    *ngIf="
                      Form1.controls['Phone'].invalid &&
                      Form1.controls['Phone'].touched &&
                      Form1.controls['Phone'].errors.required
                    "
                  >
                    Enter Phone
                  </p>
                  <p
                    class="text-danger"
                    *ngIf="
                      Form1.controls['Phone'].invalid &&
                      Form1.controls['Phone'].touched &&
                      (Form1.controls['Phone'].hasError('minlength') ||
                        Form1.controls['Phone'].hasError('maxlength'))
                    "
                  >
                    Phone number length must be
                    {{ loginData?.MobileNumberLength }}
                  </p>
                </div>
              </div>
              <div class="form-floating">
                <div class="col-md-12 form-group p-0">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Your Email Address</label
                  >
                  <input
                    formControlName="Email"
                    type="email"
                    class="form-control formHeight"
                    id="inputName"
                    placeholder="Your Email Address"
                  />
                  <p
                    style="color: red"
                    *ngIf="
                      Form1.controls['Email'].invalid &&
                      Form1.controls['Email'].touched &&
                      Form1.controls['Email'].errors.pattern
                    "
                  >
                    Please Enter valid Email
                  </p>
                </div>
              </div>
              <div
                class="form-group p-0 mt-3"
                *ngIf="honoData?.AskRemarks === 'Y'"
              >
                <label for="exampleFormControlInput1" class="form-label"
                  >Your Remarks</label
                >
                <textarea
                  formControlName="Comments"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  placeholder="Leave a comment here"
                  spellcheck="false"
                ></textarea>
              </div>

              <div class="d-grid mt-4">
                <button
                  type="submit"
                  class="btn submitButton buttonheight customButton"
                  (click)="onClick()"
                >
                  <i class="fas fa-check-circle mr-3"></i>
                  Submit your feedback
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="container" *ngIf="feedbackSubmit">
        <div class="row">
          <div class="col-md-12 text-center acknowledgmentMessage">
            <img
              src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/icon/check-mark.png"
              alt=""
            />
            <h4 class="text-success px-4">
              Thank you, Your Feedback has been submitted.
            </h4>
          </div>
        </div>
      </div>

      <app-footer></app-footer>
    </div>
  </div>
</div>

<ng-template #loadingComponent>
  <div class="d-flex justify-content-center align-items-center">
    <img
      src="https://dkzxkcjlbnjui.cloudfront.net/portal/loader/loading-page.gif"
      style="padding-top: 10%"
    />
  </div>
</ng-template>
<button
  style="display: none"
  #myloginModal
  data-bs-toggle="modal"
  data-bs-target="#myloginModal"
></button>
<!-- Login Model Starts -->
<div
  class="modal fade"
  id="myloginModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modelClose text-end">
        <button
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          class="close background-none"
          #loginModalClose
        >
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="modelImage text-center">
          <img
            src="https://dkzxkcjlbnjui.cloudfront.net/uploads/media/logo/bigdot-logo.png"
            alt=""
            class="modelLogo"
          />
        </div>
        <div
          *ngIf="this.loginData['SMSActivated'] === 'Y'"
          class="input-group my-4"
        >
          <span class="input-group-text formHeight" id="basic-addon1">
            <i class="fas fa-phone primaryColor font22"></i>
          </span>
          <input
            aria-label="Text input with dropdown button"
            class="form-control"
            id="login"
            name="Mobile"
            [(ngModel)]="MobileNumber"
            placeholder="Enter phone number"
            type="text"
            maxlength="10"
          />
        </div>
        <div
          *ngIf="this.loginData['SMSActivated'] === 'N'"
          class="input-group my-4"
        >
          <span class="input-group-text formHeight" id="basic-addon1">
            <i class="fas fa-envelope primaryColor font22"></i>
          </span>
          <input
            [(ngModel)]="EmailID"
            aria-label="Text input with dropdown button"
            class="form-control"
            id="login"
            name="Email"
            placeholder="Enter email address"
            type="text"
          />
        </div>
        <div style="color: red; padding-left: 5px" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>
        <div class="d-grid">
          <button
            class="btn text-white font16 font500 primaryBgColor buttonHeight customButton"
            (click)="getOtpMobile(true)"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Login Model Ends -->

<button
  #otpModalButton
  style="display: none"
  data-bs-toggle="modal"
  data-bs-target="#otpModal"
></button>
<!-- OTP Modal Starts-->
<div
  class="modal fade"
  id="otpModal"
  tabindex="-1"
  data-bs-backdrop="static"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modelClose text-end">
        <button
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          class="close background-none"
          #otpModalClose
        >
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="modelImage text-center">
          <img
            src="https://dkzxkcjlbnjui.cloudfront.net/uploads/media/logo/bigdot-logo.png"
            alt=""
            class="modelLogo"
          />
        </div>

        <div class="otpHeading text-center pt-4 pb-3">
          <h4>VERIFY OTP</h4>
        </div>

        <div class="otpField pb-3">
          <input
            [(ngModel)]="EnteredOTP"
            type="text"
            class="form-control text-center formHeight"
            id="inputPassword"
            placeholder="Enter OTP"
            maxlength="4"
            onkeypress="return event.keyCode >= 48 && event.keyCode <= 57"
          />
        </div>
        <div
          class="pl-2"
          style="color: red; padding-left: 5px"
          *ngIf="errorMessage"
        >
          {{ errorMessage }}
        </div>
        <div class="d-grid">
          <button
            class="btn text-white font16 font500 primaryBgColor buttonHeight customButton"
            (click)="verifyOtp()"
          >
            Verify
          </button>
          <p class="text-center pt-3">Check your SMS and enter OTP here.</p>
        </div>

        <div class="resendOTP text-center pt-2 pb-2">
          <a class="text-decoration-none" *ngIf="sendingOtp">Sending OTP...</a>
          <a class="text-decoration-none" *ngIf="otpSent">
            OTP sent successfully. Resend OTP in {{ secondsToDelay }} seconds</a
          >
          <a
            class="text-decoration-none"
            (click)="getOtpMobile(false)"
            *ngIf="!otpSent && !sendingOtp"
            style="cursor: pointer"
            >Resend OTP</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
<!-- OTP Modal Ends-->

<button
  #openloginname
  style="display: none"
  data-bs-toggle="modal"
  data-bs-target="#nameModal"
></button>
<!-- Enter Name Model Starts-->
<div
  class="modal fade"
  id="nameModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  data-bs-backdrop="static"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modelClose text-end">
        <button
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          class="close background-none"
          #nameModalClose
        >
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="modelImage text-center">
          <img
            src="https://dkzxkcjlbnjui.cloudfront.net/uploads/media/logo/bigdot-logo.png"
            alt=""
            class="modelLogo"
          />
        </div>

        <div>
          <div class="col-md-12 p-0">
            <label for="inputEmail4" class="form-label">Your Name</label>
            <input
              type="email"
              class="form-control formHeight"
              [(ngModel)]="CitizenName"
              id="inputEmail4"
              placeholder="Enter your name"
            />
          </div>
          <div class="d-grid mt-2">
            <button
              class="btn text-white font16 font500 primaryBgColor buttonHeight customButton"
              (click)="OnSaveName()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Enter Name Model Ends-->
